import React from "react";
import { Appbar, Drawer } from "..";
import Typography from "@material-ui/core/Typography";
import { Box, Link, Toolbar, Grid } from "@material-ui/core";

import { getPartnerName } from "../helpers";

const Copyright = () => {
  return (
    <Grid container display="flex" justify="center">
      <Typography variant="body2" color="textSecondary" align="center">
        {"Copyright © "}
        {getPartnerName()} Restaurant {new Date().getFullYear()}
      </Typography>
    </Grid>
  );
};
export default Copyright;
